import { CHANNEL_CARE_UPDATE_SORTING } from './action-types';
import { ISortColumn } from '../state/index'

export const updateSortingSucess = (data: ISortColumn) => ({
    type: CHANNEL_CARE_UPDATE_SORTING,
    data,
});
